import { getTripsPerMonth } from "@/api/group";
import { Modal } from "@/components";
import CustomizedHook from "@/components/project/autocomplatePro";
import Card from "@/pages/admin/dashboard/components/Card";
import { Grid, Typography, useMediaQuery } from "@mui/material";
import { BarChart } from "@mui/x-charts";
import { useCallback, useEffect, useMemo, useState } from "react";
import GroupDashboardImg from "@/assets/image/group-dashboard.png";

const monthLabels = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

function AllTripsInfo({ allTripsInfo }) {
  const [fetchingPerMonth, setFetchingPerMonth] = useState(false);
  const [year, setYear] = useState("1405");
  const md = useMediaQuery("(max-width:450px)");
  const [perMonthData, setPerMonthData] = useState([
    0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ]);
  const [barColors, setBarColors] = useState();
  useEffect(() => {
    if (!perMonthData) return;
    setBarColors(
      perMonthData.map((val) => {
        if (val > 4) return "#4caf50";
        if (val < 3) return "#f44336";
        return "#ff9800";
      }),
    );
  }, [perMonthData]);

  const yearOptions = useMemo(() => {
    return [
      {
        value: "1402",
        name: "1402",
      },
      {
        value: "1403",
        name: "1403",
      },
      {
        value: "1404",
        name: "1404",
      },
      {
        value: "1405",
        name: "1405",
      },
      {
        value: "1406",
        name: "1406",
      },
    ];
  }, []);

  const fetchTripsPerMonth = useCallback(() => {
    if (!year) return;
    setFetchingPerMonth(true);
    getTripsPerMonth(year)
      .then((res) => {
        setPerMonthData(res.map((e) => e.count));
      })
      .catch(() => {})
      .finally(() => setFetchingPerMonth(false));
  }, [year]);

  useEffect(() => {
    fetchTripsPerMonth();
  }, [year]);

  return (
    <>
      <Grid display={"flex"} flexDirection={"row"} gap={"20px"}>
        <Modal width={md ? "100%" : "30%"}>
          <Grid
            sx={{
              background: `url(${GroupDashboardImg})`,
              width: "220px",
              height: "130px",
              backgroundPositionX: "-85px",
              margin: "20px auto",
            }}
          ></Grid>
          <div
            style={{
              height: "1px",
              width: "100%",
              borderBottom: `1px solid var(--emr-darkblue)`,
            }}
          ></div>
          <Typography variant="body1" sx={{ marginTop: "10px" }}>
            سوابق اردوها
          </Typography>
          <Typography
            mt={"5px"}
            variant="caption"
            color="var(--emr-primary-color-text)"
          >
            شما میتوانید اردوهای برگزار شده خود را مشاهده کنید.
          </Typography>
        </Modal>
      </Grid>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"10px"}
        width={md ? "100%" : "420px"}
      >
        <Grid
          display={"flex"}
          flexDirection={"row"}
          gap={"10px"}
          flexWrap={"wrap"}
        >
          <Card
            title={"تعداد اردو"}
            counter={allTripsInfo.tripCount}
            unit={"اردو"}
          />
          <Card
            title={"تعداد مناطق"}
            counter={allTripsInfo.areaCount}
            unit={"منطقه"}
          />
          <Card
            title={"تعداد استان‌ها"}
            counter={allTripsInfo.stateCount}
            unit={"استان"}
          />
          <Card
            title={"تعداد شهرها"}
            counter={allTripsInfo.cityCount}
            unit={"شهر"}
          />
        </Grid>

        <Modal title={"برگزاری اردو بر اساس ماه"} width={md ? "100%" : "400px"}>
          <CustomizedHook
            width="200px"
            placeholder="انتخاب کنید."
            options={yearOptions}
            onChange={(_, newValue) => setYear(newValue.value)}
            value={yearOptions.find((e) => e.value === year)}
          />
          <Grid
            display={"flex"}
            flexDirection={"row"}
            gap={"10px"}
            alignItems={"center"}
          >
            <BarChart
              leftAxis={null}
              height={200}
              margin={{ top: 5, bottom: 60, left: 5, right: 5 }}
              series={[
                {
                  data: perMonthData,
                  type: "bar",
                },
              ]}
              xAxis={[
                {
                  scaleType: "band",
                  data: monthLabels,
                  tickLabelStyle: {
                    angle: -90,
                    textAnchor: "center",
                    fontSize: 12,
                  },
                  colorMap: {
                    type: "ordinal",
                    values: monthLabels,
                    colors: barColors,
                  },
                },
              ]}
            />
          </Grid>
        </Modal>
      </Grid>
    </>
  );
}

export default AllTripsInfo;
